<div class="popup-dialog">
    <div class="trezo-card w-100 border-radius d-block bg-white border-0 shadow-none">
        <div class="trezo-card-header d-flex align-items-center justify-content-between">
            <div class="trezo-card-title">
                <h5 class="mb-0">{{ titleText }}</h5>
            </div>
            <div class="trezo-card-subtitle">
                <button (click)="toggleClass()" type="button" class="p-0 border-0 lh-1 bg-transparent transition">
                    <i class="ri-close-fill"></i>
                </button>
            </div>
        </div>
        <form [formGroup]="frmGroup" (ngSubmit)="onSave()">
            <div class="trezo-card-content v-scroll">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Product Name <span class="text-danger">*</span>
                            </label>
                            <input appCapitalizeWords type="text" class="form-control" placeholder="Product Name"
                                formControlName="productNameControl" maxlength="200" />
                            <div class="form-text text-danger"
                                *ngIf="isSubmitted && f['productNameControl']!.hasError('required')">
                                Product Name is required.
                            </div>
                            <div class="form-text text-danger"
                                *ngIf="isSubmitted && f['productNameControl']!.hasError('onlyWhitespace')">
                                Product Name can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">Product Code</label>
                            <input appCapitalizeWords type="text" class="form-control" placeholder="Product Code (optional)"
                                formControlName="productCodeControl" maxlength="100" />
                            <div class="form-text text-danger"
                                *ngIf="isSubmitted && f['productCodeControl']!.hasError('onlyWhitespace')">
                                Product Code can not be only whitespace.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="main-label d-block fw-medium text-black">
                                Photo <span class="text-danger">*</span>
                            </label>
                            <input #fileInput type="file" accept="image/*" class="form-control"
                                (change)="onPhotoSelected($event)" />
                            <div class="form-text text-danger"
                                *ngIf="isSubmitted && f['photoUrlControl']!.hasError('required') && !zekvo.photoBase64">
                                Photo is required.
                            </div>
                            <div class="mt-2" *ngIf="zekvo.photoBase64 || zekvo.photoUrl">
                                <img [src]="zekvo.photoBase64 || getImageUrl(zekvo.photoUrl)" alt="Photo preview"
                                    style="max-width: 220px; max-height: 220px; border: 1px solid #ccc; border-radius: 6px;" />
                                <div class="mt-2">
                                    <button type="button" class="btn btn-sm btn-outline-danger"
                                        (click)="removeImage()">Remove image</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="trezo-card-footer d-flex justify-content-end gap-2 p-3">
                <button type="button" class="btn btn-secondary" (click)="toggleClass()">Cancel</button>
                <button type="submit" class="btn btn-primary">{{ titleButton }}</button>
            </div>
        </form>
    </div>
</div>
